import React from 'react'
import { VEHICLE_STATE_FORM } from 'constants/qnState'
import { LocationStateInfo, LocationTypes } from 'states/QnState'
import { getCheckedLabels } from 'utils/qnState'
import styled from 'styled-components'

/**
 * 周辺情報確認用コンテンツ
 */
const SurroundingConfirmContent: React.FC<SurroundingConfirmContentProps> = (
  props
) => {
  const { locationState } = props

  // 表示データの生成
  const surroundingItems = (): Array<string> => {
    switch (locationState.locationType) {
      // 一般道
      case LocationTypes.localLoad:
        return [locationState.localLoadSupplement]
      // 高速道路
      case LocationTypes.highway:
        return [
          VEHICLE_STATE_FORM.highwayLocation.options[
            locationState.highwayLocation
          ],
          locationState.highwaySupplement,
        ]
      // 自宅・通常保管場所
      case LocationTypes.home:
        return getCheckedLabels(
          VEHICLE_STATE_FORM.homeStorageLocation.options,
          locationState.homeStorageLocation
        ).concat(locationState.homeStorageSupplement)
      // 上記以外の車庫・駐車場
      case LocationTypes.garageParking:
        return getCheckedLabels(
          VEHICLE_STATE_FORM.otherStorageLocation.options,
          locationState.otherStorageLocation
        ).concat(locationState.otherStorageSupplement)
      // 舗装されていない道路
      case LocationTypes.noPavedLoad:
        return [locationState.noPavedLoadSupplement]
      // その他
      case LocationTypes.other:
      default:
        return [locationState.otherSupplement]
    }
  }

  // 表示データ
  const items = [
    VEHICLE_STATE_FORM.locationType.options[locationState.locationType],
  ].concat(surroundingItems())

  return (
    <SurroundingConfirmArea>
      {items.map(
        (item, index) =>
          item && (
            <SurroundingItemValueChild key={index}>
              {item}
            </SurroundingItemValueChild>
          )
      )}
    </SurroundingConfirmArea>
  )
}

export type SurroundingConfirmContentProps = {
  locationState: LocationStateInfo
}

const SurroundingConfirmArea = styled.ul`
  padding-left: 34px;
`

const SurroundingItemValueChild = styled.li`
  word-wrap: break-word;
`

export default React.memo<SurroundingConfirmContentProps>(
  SurroundingConfirmContent
)
